module.exports = __webpack_public_path__ + "static/media/agencjapracy.38d7577d.svg";